import { render, staticRenderFns } from "./SaleManagement.vue?vue&type=template&id=073b99c6"
import script from "./SaleManagement.vue?vue&type=script&lang=js"
export * from "./SaleManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports